import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { ScopedCssBaseline } from '../StyleBase';
import useFormControl from './useFormControl';
import Text from '../Text';
const Root = styled(Text).withConfig({
  displayName: "FormLabel__Root",
  componentId: "aqg60j-0"
})(["", " display:block;margin:0 0 var(--size-spacing-02) 0;color:var(--color-gray-100);&:hover{color:var(--color-gray-100);}", " ", ""], ScopedCssBaseline, ({
  forwardedAs
}) => forwardedAs === 'legend' && css(["margin-bottom:var(--size-spacing-03);"]), ({
  disabled
}) => disabled && css(["color:var(--color-gray-80);&:hover{color:var(--color-gray-80);}"]));
const Required = styled((_ref) => {
  let rest = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("span", rest, ' *');
}).withConfig({
  displayName: "FormLabel__Required",
  componentId: "aqg60j-1"
})(["color:var(--color-red-60);"]);

var _ref3 = /*#__PURE__*/React.createElement(Required, null);

const FormLabel = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    children,
    disabled,
    required,
    as
  } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, ["children", "disabled", "required", "as"]);

  const {
    disabled: disabledContext,
    required: requiredContext
  } = useFormControl();
  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref
  }, rest, {
    token: Text.tokens.TEXT_MD_BOLD,
    forwardedAs: as,
    disabled: disabled || disabledContext
  }), children, (required || requiredContext) && _ref3);
});
FormLabel.displayName = 'FormLabel';
FormLabel.defaultProps = {
  as: 'label'
};
process.env.NODE_ENV !== "production" ? FormLabel.propTypes = {
  /**
   * sets label content
   */
  children: PropTypes.node.isRequired,

  /**
   * sets the input element this label refers
   */
  htmlFor: PropTypes.string,

  /**
   * sets disabled style for Label
   */
  disabled: PropTypes.bool,

  /**
   * Sets the required style (*)
   */
  required: PropTypes.bool
} : void 0;
export default FormLabel;